export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-r from-slate-800 to-slate-900 text-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-12">
          {/* Company Info */}
          <div className="md:col-span-2">
            <div className="flex items-center space-x-3 mb-6">
              <div className="w-12 h-12 bg-gradient-to-br from-cyan-500 to-blue-600 rounded-xl flex items-center justify-center">
                <i className="ri-sailboat-line text-white text-2xl"></i>
              </div>
              <div>
                <h3 className="text-2xl font-bold bg-gradient-to-r from-cyan-400 to-blue-400 bg-clip-text text-transparent">
                  MAR AZUL
                </h3>
                <p className="text-sm text-gray-400">Renta de Yates Los Cabos</p>
              </div>
            </div>
            <p className="text-gray-300 mb-6 leading-relaxed">
              <strong>MAR AZUL</strong> - Líderes en renta de lanchas y yates en Cabo San Lucas. 
              Ofrecemos experiencias náuticas de lujo con la más alta calidad de servicio 
              y las mejores embarcaciones del Mar de Cortés.
            </p>
            <div className="flex space-x-4">
              <button className="w-12 h-12 bg-gradient-to-r from-blue-500 to-blue-600 rounded-full flex items-center justify-center hover:from-blue-400 hover:to-blue-500 transition-all transform hover:scale-110 cursor-pointer whitespace-nowrap">
                <i className="ri-facebook-fill text-xl"></i>
              </button>
              <button className="w-12 h-12 bg-gradient-to-r from-pink-500 to-pink-600 rounded-full flex items-center justify-center hover:from-pink-400 hover:to-pink-500 transition-all transform hover:scale-110 cursor-pointer whitespace-nowrap">
                <i className="ri-instagram-fill text-xl"></i>
              </button>
              <a 
                href="https://wa.me/522291578562" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-12 h-12 bg-gradient-to-r from-green-500 to-green-600 rounded-full flex items-center justify-center hover:from-green-400 hover:to-green-500 transition-all transform hover:scale-110 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-whatsapp-fill text-xl"></i>
              </a>
              <button className="w-12 h-12 bg-gradient-to-r from-red-500 to-red-600 rounded-full flex items-center justify-center hover:from-red-400 hover:to-red-500 transition-all transform hover:scale-110 cursor-pointer whitespace-nowrap">
                <i className="ri-youtube-fill text-xl"></i>
              </button>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h5 className="text-xl font-bold mb-6 text-white">Enlaces Rápidos</h5>
            <ul className="space-y-3">
              <li>
                <button 
                  onClick={() => scrollToSection('inicio')}
                  className="text-gray-300 hover:text-cyan-400 transition-colors cursor-pointer whitespace-nowrap"
                >
                  Inicio
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('productos')}
                  className="text-gray-300 hover:text-cyan-400 transition-colors cursor-pointer whitespace-nowrap"
                >
                  Nuestra Flota
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('sobre-nosotros')}
                  className="text-gray-300 hover:text-cyan-400 transition-colors cursor-pointer whitespace-nowrap"
                >
                  Sobre Nosotros
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('contacto')}
                  className="text-gray-300 hover:text-cyan-400 transition-colors cursor-pointer whitespace-nowrap"
                >
                  Contacto
                </button>
              </li>
              <li>
                <button className="text-gray-300 hover:text-cyan-400 transition-colors cursor-pointer whitespace-nowrap">
                  Términos y Condiciones
                </button>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h5 className="text-xl font-bold mb-6 text-white">Servicios</h5>
            <ul className="space-y-3 text-gray-300">
              <li>• Alquiler de Mega Yates</li>
              <li>• Pesca Deportiva</li>
              <li>• Tours al Arco</li>
              <li>• Bodas en Yates</li>
              <li>• Eventos Corporativos</li>
              <li>• Celebraciones Privadas</li>
              <li>• Servicios Todo Incluido</li>
            </ul>
          </div>
        </div>

        {/* Contact Info Bar */}
        <div className="border-t border-gray-700 pt-8 mb-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-center md:text-left">
            <div className="flex items-center justify-center md:justify-start">
              <i className="ri-map-pin-line text-cyan-400 mr-2"></i>
              <span className="text-gray-300 text-sm">
                Blvd. Paseo de la Marina 57-D, Marina, 23450 Cabo San Lucas
              </span>
            </div>
            <div className="flex items-center justify-center md:justify-start">
              <i className="ri-phone-line text-cyan-400 mr-2"></i>
              <span className="text-gray-300 text-sm">+52 229 157 8562</span>
            </div>
            <div className="flex items-center justify-center md:justify-start">
              <i className="ri-mail-line text-cyan-400 mr-2"></i>
              <span className="text-gray-300 text-sm">ventas@vipcaboyachtrentals.com</span>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm mb-4 md:mb-0">
              © 2024 MAR AZUL - Renta de Lanchas y Yates en Cabo San Lucas. Todos los derechos reservados.
            </p>
            <div className="flex items-center space-x-4 text-sm text-gray-400">
              <span>Desarrollado con</span>
              <a 
                href="https://readdy.ai/?origin=logo" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-cyan-400 hover:text-cyan-300 transition-colors cursor-pointer"
              >
                Readdy.ai
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}